export enum ReportFileFormat {
  XLSX = 'xlsx',
  ZIP = 'zip'
}


export type ReportGenerateParams = {
  reportID: string
  format: ReportFileFormat
}

export type GenerateFileResult = string
